/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1BatchTransferState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_BATCH_TRANSFER_STATE_ENTITY_NAME = 'ixc.funding.v1.BatchTransfer';
export const ixcFundingV1BatchTransferStateEntity = new schema.Entity<IxcFundingV1BatchTransferState>(IXC_FUNDING_V1_BATCH_TRANSFER_STATE_ENTITY_NAME, {}, { idAttribute: 'batchTransferId' });

